module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0143.jpg?v=9867b5e0";